import { createTypes } from '../../utils';

const types = createTypes('salesforceChat', [
    'SF_CHANGE_BTN_STATE'
]);

export default types;
